/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/rules-of-hooks */

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { StyleSheet, View, ScrollView, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';
import { isWeb, fullWidth, fullHeight } from '@global/screens';
import Colors from '@global/colors';
import ModalFull from '@components/modal/ModalFull';
import Button from '@components/form/Button';
import FileInput from '@components/form/FileInput';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';

import { MsCatalog } from '@api/ms-catalog';
import { showPopup } from '@/store/modal';

const submitStyle = {
  ...(isWeb
    ? {
        width: isWeb ? 'calc(100% - 30px)' : fullWidth - 30,
      }
    : { width: fullWidth - 30 }),
  marginHorizontal: 15,
};

const pdfSectionForm = ({
  updateInitPDF,
  id,
  sectionId = '',
  editData = null,
  show,
  onClose,
  onSubmit,
}) => {
  const dispatch = useDispatch();
  const [payload, setPayload] = useState({
    pdf_documents: [
      {
        url: '',
      },
    ],
  });

  useEffect(() => {
    let mounted = true;
    if (mounted && show) {
      if (editData) {
        setPayload({
          pdf_documents: [
            {
              url: editData ? editData : '',
            },
          ],
        });
      }
    } else {
      setPayload({
        pdf_documents: [
          {
            url: '',
          },
        ],
      });
    }
    return () => {
      mounted = false;
    };
  }, [show]);

  const isDisabledSubmit = () => {
    let result = false;

    if (payload?.pdf_documents?.length) {
      for (let i = 0; i < payload.pdf_documents.length; i++) {
        const item = payload.pdf_documents[i];
        if (!item?.url) {
          result = true;
        }
      }
    } else {
      result = true;
    }

    return result;
  };

  const addPdfInput = () => {
    setPayload((prevPayload) => ({
      pdf_documents: [
        ...prevPayload.pdf_documents,
        {
          url: '',
        },
      ],
    }));
  };

  const generatePdfName = (index) => {
    return `pdf-section-${index + 1}.pdf`;
  };

  const onSubmitForm = async () => {
    const body = {
      pdf_documents: payload.pdf_documents,
    };

    if (!id) {
      updateInitPDF('pdf_documents', { ...body, type: 'pdf_documents' }, false);
      onClose();
      return;
    }

    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      let process = null;
      if (editData) {
        process = await MsCatalog.updateCMSSection(
          id,
          'pdf_documents',
          sectionId,
          payload,
        );
      } else {
        process = await MsCatalog.createCMSSection(
          id,
          'pdf_documents',
          payload,
        );
      }
      if (process?.data?.data?._id || process?.data?.success) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        onSubmit();
        setPayload({ pdf_documents: [{ url: '' }] });
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const addNewForm = () => {
    const newpayload = {
      type: 'pdf_documents',
      ...payload,
    };
    updateInitPDF('pdf_documents', newpayload, true);
    onClose();
  };

  return (
    <ModalFull
      title="Add PDF Section"
      show={show}
      back={isWeb ? false : true}
      width={isWeb ? 350 : '100%'}
      onClose={() => onClose()}>
      <ScrollView
        style={{ width: '100%', maxHeight: fullHeight - (isWeb ? 55 : 55) }}>
        <View style={{ width: '100%', padding: isWeb ? 15 : 20 }}>
          <View>
            <View style={styles.formCenter}>
              <Image
                style={{ width: 50, height: 66, marginBottom: 16 }}
                width={50}
                height={66}
                source={require('@assets/img/icons/pdf-upload.svg')}
                svg={true}
              />
            </View>
            {payload.pdf_documents.map((item, idx) => (
              <View key={idx}>
                <View style={[styles.formSpace, styles.formCenter]}>
                  <FileInput
                    hidelabel
                    value={
                      item.url ? item.description || generatePdfName(idx) : ''
                    }
                    isRequired
                    isCSV
                    withFileName
                    onChange={(value) => {
                      const old = JSON.parse(JSON.stringify(payload));
                      old.pdf_documents[idx].url = value?.url || value;
                      old.pdf_documents[idx].description = value?.name || '';
                      setPayload(old);
                    }}
                  />
                </View>
              </View>
            ))}
            {payload.pdf_documents[0]?.url && (
              <TouchableOpacity
                style={styles.alignRight}
                onPress={() => addPdfInput()}>
                <SociollaText type="regular" style={{ color: Colors.primary }}>
                  + More PDF
                </SociollaText>
              </TouchableOpacity>
            )}
          </View>
        </View>
        <View
          style={{
            width: '100%',
            paddingVertical: 15,
            justifyContent: 'center',
            borderTopColor: isWeb ? 'transparent' : Colors.grey0,
            borderTopWidth: 1,
          }}>
          <Button
            rounded={true}
            buttonStyle={submitStyle}
            disabledStyle={submitStyle}
            disabled={isDisabledSubmit()}
            title={
              <SociollaText
                type="bold"
                style={{
                  fontSize: 14,
                  letterSpacing: 0.5,
                  color: Colors.white,
                }}>
                Add
              </SociollaText>
            }
            onPress={() => (editData ? onSubmitForm() : addNewForm())}
          />
        </View>
      </ScrollView>
    </ModalFull>
  );
};

const styles = StyleSheet.create({
  formSpace: { marginBottom: 10 },
  formCenter: { justifyContent: 'center', alignItems: 'center' },
  alignRight: { alignItems: 'flex-end' },
});

export default pdfSectionForm;
